import Enum from "./Enum";

export default Enum.create( {
	BINARY: "BINARY",
	PERCENTAGE: "PERCENTAGE",
	CURRENCY: "CURRENCY",
	NUMERIC: "NUMERIC",
} );
